<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
    <v-card>
      <v-card-title class="primary white--text">
        Marcação de faltas
      </v-card-title>

      <v-card-text v-if="fields != null" class="mt-2">
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="fields.fault_type_id"
                    :items="types"
                    :item-text="item=>item.description"
                    item-value="id"
                    clearable
                    hint="Para remover a falta basta clicar na cruz da dropdown e clicar gravar"
                    persistent-hint
                    outlined
                    label="Tipo de falta *"
                />
            </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions v-if="fields != null">
        <v-btn class="success" @click="submit">Gravar</v-btn>
        <v-spacer />
        <v-btn text @click="$emit('close')">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Faults from '@/api/Faults.js'

export default {
  name: 'Faults',
  props: {
    // Para usar com v-model no componente pai
    value: {
      type: Boolean,
      default: false,
    },
    // Objeto com os campos indicados
    fault: {
      type: Object,
      required: true
      // Exemplo de estrutura esperada:
      // {
      //   CodigoMO: String,
      //   DataMov: String|Date,
      //   day: String|Date,
      //   fault_type_id: String|Number,
      //   funcionario: String,
      //   work_id: String|Number
      // }
    },
  },
  data(){
    return{
        types: [],
        fields: null
    }
  },
  mounted(){
    this.fields = this.fault
    this.fillBaseData()
  },
  methods:{
    submit(){
        this.$emit('add-fault', this.fields.fault_type_id)
    },
    fillBaseData(){
        Faults.getTypes().then((resp)   =>  {
            this.types = resp.data
        })
    }
  }
};
</script>

<style scoped>
/* Estilos adicionais se necessário */
</style>
